module.exports = __webpack_public_path__ + "img/INSTYLE-PLUS-SB3-black.423d089e.jpg";